import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Drawer, Row, Col, Button, Modal } from 'antd'
import moment from 'moment'
import EventDiff from './event.diff'
import {
  importFromMaster,
  isEventUpdated,
  getEvents,
  getDifference,
  discardMasterChanges,
} from '../../store/action/event.action'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import _ from 'lodash'

const EventDrawer = (props) => {
  const [details, setDetails] = useState(false)
  const [importids, setImportIds] = useState([{ type: '', ids: [] }])

  useEffect(() => {
    if (props.differences) {
      var iids = []
      props.differences.forEach((e) =>
        iids.push({
          // type: e.type, ids: [], discardids: [],
          // skipids: e.events?.map(t => {
          //    return (t.isUpdated && !t.isSame) ? (t.parent ? t.parent?._id : t.child?._id) : undefined;
          // }).filter(t => t != undefined )
          type: e.type,
          skipids: [],
          discardids: [],
          ids: e.events
            ?.map((t) => {
              return t.isUpdated && !t.isSame
                ? t.parent
                  ? t.parent?._id
                  : t.child?._id
                : undefined
            })
            .filter((t) => t != undefined),
        })
      )
      console.log(iids)
      setImportIds(iids)
    }
  }, [props.differences])

  const acceptChanges = async (iids) => {
    console.log(iids)
    var resp = await props.importChanges({
      customer: props.customer?._id,
      company: props.company?._id,
      importids: iids ? iids : JSON.parse(JSON.stringify(importids)),
    })

    if (resp) {
      await props.isEventUpdated({
        customer: props.customer?._id,
        company: props.company?._id,
      })
      await props.getEvents({
        surgerytype: props.surgerytype,
        customer: props.customer?._id,
        company: props.company?._id,
      })
      await props.getDiffs({
        customer: props.customer?._id,
        company: props.company?._id,
      })
    }
    setDetails(false)
  }

  const discardChanges = async () => {
    var resp = await props.discardChanges({
      customer: props.customer?._id,
      company: props.company?._id,
    })
    if (resp)
      await props.isEventUpdated({
        customer: props.customer?._id,
        company: props.company?._id,
      })
    setDetails(false)
  }

  const handleAcceptAll = () => {
    var iids = JSON.parse(JSON.stringify(importids))
    for (var i = 0; i < props.differences.length; i++) {
      var index = _.findIndex(importids, { type: props.differences[i].type })
      iids[index].ids = props.differences[i].events
        .filter((e) => e.isUpdated)
        .map((e) => (e.parent ? e.parent._id : e.child._id))
    }
    acceptChanges(iids)
    // setImportIds(iids);
    // setTimeout(() => acceptChanges(iids), 0)
  }

  const handleAcceptAllClick = () => {
    Modal.confirm({
      title: 'Confirm',
      icon: <ExclamationCircleOutlined />,
      content: 'Do you want to accept all the new changes?',
      okText: 'Yes',
      cancelText: 'No',
      onOk: handleAcceptAll,
    })
  }

  const canAccept = () => {
    for (var i = 0; i < importids.length; i++)
      if (importids[i].ids?.length > 0) return true
    return false
  }
  const renderFooter = () => {
    return (
      <Row justify='end' wrap={false} gutter={10}>
        <Col>
          {/* <Col style={{marginLeft: "auto"}}> */}
          <Button className='et-cancel-round-btn' type='primary' shape='round'>
            Discard
          </Button>
        </Col>
        <Col>
          <Button className='et-round-btn' type='primary' shape='round'>
            Skip
          </Button>
        </Col>
        <Col>
          <Button className='et-round-btn' type='primary' shape='round'>
            Accept
          </Button>
        </Col>
      </Row>
    )
  }

  const renderCard = () => {
    return (
      <Row className='notification-card'>
        <Col flex='auto'>
          <h3>
            {props.customer ? props.customer?.companyObj?.name : 'Super Admin'}{' '}
            has modified Reminders on your behalf. Would you like to accept
            these changes?
          </h3>
          <Row>
            <Col style={{ fontWeight: 500 }}>UpdatedAt : &nbsp; </Col>
            <Col>
              <i>
                {' '}
                {moment(moment.utc(props.time).toDate())
                  .local()
                  .format('MM/DD/YYYY hh:mm a')}
              </i>
            </Col>
          </Row>
          <br />
          <Row wrap={false} gutter={5}>
            <Col>
              <Button
                className='et-cancel-round-btn'
                type='primary'
                shape='round'
                size='small'
                onClick={discardChanges}
              >
                <a>Discard</a>
              </Button>
            </Col>
            <Col
              style={{ marginLeft: 'auto' }}
              onClick={() => setDetails(true)}
            >
              <Button
                className='et-round-btn'
                type='primary'
                shape='round'
                size='small'
              >
                <a>Details</a>
              </Button>
            </Col>
            <Col hidden>
              <Button
                className='et-round-btn'
                type='primary'
                shape='round'
                size='small'
                onClick={handleAcceptAllClick}
              >
                <a>Accept</a>
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }

  return (
    <Drawer
      className='event-drawer'
      visible={props.visible}
      onClose={() => props.closeDrawer()}
      destroyOnClose
      title={'Notifications'}
      width={'400px'}
    >
      {props.isUpdated ? (
        renderCard()
      ) : (
        <Row justify='center'>
          <Col>
            <br />
            <br />
            <i>No notifications found.</i>
          </Col>
        </Row>
      )}
      {/* <Drawer 
                className="event-drawer" 
                visible={details}
                onClose={() => setDetails(false)} 
                destroyOnClose
                title={"Details"}
                width={"720px"}
                footer={renderFooter()}
            >
                <EventDiff setImportIds={setImportIds} importids={importids} />
            </Drawer> */}
      <EventDiff
        setDetails={setDetails}
        details={details}
        setImportIds={setImportIds}
        importids={importids}
        acceptChanges={acceptChanges}
      />
    </Drawer>
  )
}

EventDrawer.propTypes = {}

const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    time: state.event.updatedAt,
    isUpdated: state.event.isUpdated,
    company: state.profile.company,
    surgerytype: state.event.surgerytype,
    differences: state.event.differences,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    importChanges: (params) => dispatch(importFromMaster(params)),
    isEventUpdated: (params) => dispatch(isEventUpdated(params)),
    getEvents: (params) => dispatch(getEvents(params)),
    getDiffs: (params) => dispatch(getDifference(params)),
    discardChanges: (params) => dispatch(discardMasterChanges(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventDrawer)
